/**
 * Build-time / runtime configuration for the portal SPA.
 *
 * In production these come from a small `env.js` file the nginx
 * container writes at startup (so the same image is promoted across
 * environments with a different portal AAD client id). In dev they come
 * from `.env` files at the portal-ui root.
 *
 * `msalClientId` empty → the portal AAD app registration does not exist
 * yet; the SPA renders the static landing only and the wizard sign-in is
 * unavailable. Filling it in (ConfigMap-only change) activates the
 * wizard.
 */
type RuntimeConfig = {
  msalClientId: string;
  msalAuthority: string;
  apiBaseUrl: string;
};

declare global {
  interface Window {
    __FINN_PORTAL_CONFIG__?: Partial<RuntimeConfig>;
  }
}

const fromWindow =
  (typeof window !== "undefined" && window.__FINN_PORTAL_CONFIG__) || {};

// Multi-tenant authority: customer admins sign in against their own M365
// tenant, not a fixed one.
const DEFAULT_AUTHORITY = "https://login.microsoftonline.com/organizations";

export const env: RuntimeConfig = {
  msalClientId:
    fromWindow.msalClientId ?? import.meta.env.VITE_MSAL_CLIENT_ID ?? "",
  msalAuthority:
    fromWindow.msalAuthority ??
    import.meta.env.VITE_MSAL_AUTHORITY ??
    DEFAULT_AUTHORITY,
  apiBaseUrl:
    fromWindow.apiBaseUrl ??
    import.meta.env.VITE_API_BASE_URL ??
    "/portal/api/v1",
};
